import { Component, OnInit } from "@angular/core";
import * as ZoomAuthentication from "../../../assets/core-sdk/ZoomAuthentication.js/ZoomAuthentication";
import { LivenessCheckProcessor } from "../../../assets/processors/LivenessCheckProcessor";
import {ThemeHelpers} from "../../../assets/processors/helpers/ThemeHelpers";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {ActivatedRoute, Router} from "@angular/router";
import { QueryEnrollmentResponse, UploadFaceRequest } from 'src/app/services/idnow-backend-services-domain';
import { IdnowBackendsService } from 'src/app/services/idnow-backend-services';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from 'src/app/services/notification.service';
import { SampleAppUtilities } from 'src/app/utilities/SampleAppUtilities';
const ZoomSDK = ZoomAuthentication.ZoomSDK;
declare var ZoomGlobalState: any;

@Component({
  selector: 'idnow-selfie',
  templateUrl: './selfie.component.html',
  styleUrls: ['./selfie.component.css']
})

export class SelfieComponent implements OnInit {
  private selfieImage : any;
  private facemap : string;
  private sessionId: string;
  private baseResponse: QueryEnrollmentResponse;

  constructor(private ngxService: NgxUiLoaderService, private router: Router, 
    private route: ActivatedRoute, private idnowServices : IdnowBackendsService, 
    private ngxServiceSt: NgxUiLoaderService, private notifyService : NotificationService)  { }

  ngOnInit(): void {
    this.ngxService.start();
    
    // Set a the directory path for other ZoOm Resources.
    ZoomSDK.setResourceDirectory("../../../assets/core-sdk/ZoomAuthentication.js/resources");
    ThemeHelpers.setAppTheme("Pseudo-Fullscreen");
    // Set the directory path for required ZoOm images.
    ZoomSDK.setImagesDirectory("../../../assets/core-sdk/zoom_images");

    // Initialize ZoOm and configure the UI features.
    ZoomSDK.initialize(ZoomGlobalState.DeviceLicenseKeyIdentifier, this.initializeComplete.bind(this));
    //ZoomSDK.initializeWithLicense(ZoomGlobalState.SFTPLicenseText, 
    //ZoomGlobalState.DeviceLicenseKeyIdentifier, ZoomGlobalState.PublicFaceMapEncryptionKey, this.initializeComplete.bind(this));

  }

  // Perform Liveness Check.
  onLivenessCheckPressed() {
    SampleAppUtilities.fadeOutMainUIAndPrepareForZoOm();
    new LivenessCheckProcessor(this.onProcessingComplete, this.onServerSessionTokenError);
    this.ngxService.stop();
  }

  receivemessage(evt:any){
    console.log(evt.data);
  }

  

  // Show the final result and transition back into the main interface.
  onProcessingComplete(isSuccess: boolean, zoomSessionResult: ZoomAuthentication.ZoomSessionResult) {
    //SampleAppUtilities.showResultStatusAndMainUI(isSuccess, zoomSessionResult);
    SampleAppUtilities.showResultStatusAndMainUI(isSuccess, zoomSessionResult);

    if(isSuccess || zoomSessionResult.status == 0){
      //this.ngxServiceSt.start();

      localStorage.setItem('sessionId', zoomSessionResult.sessionId);
      console.log("baseResponse", zoomSessionResult);
      let sesionID = zoomSessionResult.sessionId;
      //window.parent.postMessage(zoomSessionResult, '*');
      zoomSessionResult.faceMetrics.getFaceMapBase64(function(faceMapBase64: any) {
        localStorage.setItem('faceMapBase64', faceMapBase64);

        let data = {
          sesionID: sesionID,
          faceMapBase64: faceMapBase64
        }
        let windowRef=null;

        window.parent.postMessage({"sesionID":sesionID, "faceMapBase64":faceMapBase64, "foto":zoomSessionResult.faceMetrics.getAuditTrailBase64JPG()[2]},'*');
        //windowRef = window.open("/login","child", "toolbar=no,location=no,directories=no,status=no,menubar=no,titlebar=no,fullscreen=no,scrollbars=1,resizable=no,width=430,height=220,left=500,top=100");
        //windowRef.addEventListener(data,this.receivemessage.bind(this), false);

        //window.parent.postMessage(data, '*');
      
      });



      
      
      //localStorage.setItem('foto', zoomSessionResult.faceMetrics.getAuditTrailBase64JPG()[2];
      
     
      /*try{
        this.baseResponse = JSON.parse(localStorage.getItem('baseResponse'));
        console.log("baseResponse", this.baseResponse);
        let uploadFaceRequest = UploadFaceRequest.buildTuyaRequest(this.baseResponse);
        console.log("uploadFaceRequest",uploadFaceRequest );
        
        localStorage.setItem('base64Face', zoomSessionResult.faceMetrics.auditTrail[2] as string);
        localStorage.setItem('sessionId', zoomSessionResult.sessionId);

        
      }catch(error){
        this.notifyService.showError("Lo lamentamos, no pudimos procesar su fotografia", "ERROR")
      }*/
    }

   // this.moveOn("/finalResult");
  }

  moveOn(route) {
    this.router.navigate([route]);
  }

  onServerSessionTokenError() {
    SampleAppUtilities.handleErrorGettingServerSessionToken();
  }

  // Updates UI when initialization completes
  initializeComplete() {
    // this.ngxService.stop();
    SampleAppUtilities.fadeInMainUI();
    // display status
    (document.getElementById("status") as HTMLElement).innerHTML = ZoomSDK.getFriendlyDescriptionForZoomSDKStatus(ZoomSDK.getStatus());
    this.onLivenessCheckPressed();
    // enable button
    //  (document.getElementById("liveness-button") as HTMLButtonElement).disabled = false;
  }
}
